export default __webpack_public_path__ + "static/media/Logo.9bf50c66.png";